import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Spinner,
  Badge,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

import toast from "react-hot-toast";
import { Triangle } from "react-loader-spinner";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { imageBaseApi } from "../../../utilis/imageHelper";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";
import DestinationWidgetService from "../../../services/KangarooServices/Intelligence/DestinationWidgetService";
import InstituteWidgetService from "../../../services/KangarooServices/Intelligence/InstituteWidgetService";

const InstituteDetailWidget = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchDetail = async () => {
    try {
      setLoading(true);
      const response = await InstituteWidgetService.getdetail(id);
      setDetails(response);
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.error("Failed to load details");
      setLoading(false);
      navigate("/who-we-are");
    }
  };

  useEffect(() => {
    // if () {
    fetchDetail();
    // }
  }, [id]);

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Who We Are Details" pageTitle="Who We Are" />
          <Card>
            <CardBody>
              <div className="d-flex justify-content-center align-content-center align-items-center text-center py-5">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }

  if (!details) {
    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Who We Are Details" pageTitle="Who We Are" />
          <Card>
            <CardBody>
              <div className="text-center py-5">
                <i className="ri-file-damage-line display-1 text-muted"></i>
                <h5 className="mt-4 mb-2">No Details Found</h5>
                <Button color="primary" onClick={() => navigate("/who-we-are")}>
                  Back to List
                </Button>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }
  const handleEdit = (slug) => {
    navigate(`/who-we-are/update/${slug}`);
  };
  const WidgetCard = ({ item }) => {
    return (
      <Card className="h-100 border-0 shadow-sm">
        {/* Image */}
        {item.image?.url ? (
          <img
            src={`${imageBaseApi}${item.image?.url}`}
            alt={item.widgetName}
            className="img-fluid rounded-top"
            style={{ height: "200px", objectFit: "cover" }}
          />
        ) : (
          <div
            className="d-flex align-items-center justify-content-center bg-light rounded-top"
            style={{ height: "200px" }}
          >
            <i className="ri-image-line display-4 text-muted"></i>
          </div>
        )}

        <CardBody>
          {/* Destination */}
          <span className="badge bg-primary-subtle text-primary mb-2">
            {item.name}
          </span>

          {/* Widget Name */}
          <h5 className="fw-bold mb-2">{item.headingName}</h5>

          {/* Description */}
          <div
            className="content-html small text-muted"
            dangerouslySetInnerHTML={{
              __html: item.description,
            }}
          />
        </CardBody>
      </Card>
    );
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Institute Widget Detail"
          pageTitle="Institute Widget"
          breadcrumbItems={[
            { title: "Back to List", link: "/institute-widget" },
          ]}
        />

        {/* HERO / BANNER */}
        {/* <Card className="mb-4 border-0 shadow-sm">
          <CardBody className="p-0">
            {details?.image ? (
              <img
                src={`${imageBaseApi}${details.image.url}`}
                alt="Widget Banner"
                className="img-fluid w-100 rounded-top"
                style={{ maxHeight: "340px", objectFit: "cover" }}
              />
            ) : (
              <div
                className="d-flex align-items-center justify-content-center bg-light"
                style={{ height: "260px" }}
              >
                <i className="ri-image-line display-3 text-muted"></i>
              </div>
            )}

         
            <div className="p-4 border-top">
              <h4 className="fw-bold mb-1">{details?.name}</h4>
              <p className="text-muted mb-0">
                <i className="ri-layout-line me-1"></i>
                Widget Information
              </p>
            </div>
          </CardBody>
        </Card> */}

        {/* DETAILS GRID */}
        <Row className="g-4">
          {details?.map((item) => (
            <Col lg={6} key={item.id}>
              <WidgetCard item={item} />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default InstituteDetailWidget;
